// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3DW-Y","content":"RecentSearches_content__12YnQ"};